import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const SidebarCollapseContext = createContext({
  collapsed: false,
  setCollapsed: () => {},
  toggleCollapsed: () => {},
});

export const SidebarCollapseProvider = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  const value = useMemo(
    () => ({ collapsed, setCollapsed, toggleCollapsed }),
    [collapsed, toggleCollapsed]
  );

  return (
    <SidebarCollapseContext.Provider value={value}>
      {children}
    </SidebarCollapseContext.Provider>
  );
};

export const useSidebarCollapse = () => useContext(SidebarCollapseContext);
